import { combineReducers } from "redux";
import changeStep from "./signUp.reducer";
import product from "./product.reducer"
import escapeBucksReducers from "./escapeBuck.reducer";
import loginRedirectReducer from "./loginRedirectReducer";


const rootReducers = combineReducers(
    {
        changeStep,
        product,
        escapeBucksRedux: escapeBucksReducers,
        loginRedirectReducer
    }
)
export default rootReducers